import { render, staticRenderFns } from "./HomeProducts.vue?vue&type=template&id=3b333f34&name=article-products&"
import script from "./HomeProducts.vue?vue&type=script&lang=js&"
export * from "./HomeProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports